import * as React from "react";
import { memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLock = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 18,
		height: 11,
		x: 3,
		y: 11,
		rx: 2,
		ry: 2
	}), /* @__PURE__ */ _jsx("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" })]
});
const Memo = memo(SvgLock);
export default Memo;
